import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import { GeneralInformationForm } from './Form';
import ButtonDefault from '@/components/ui/ButtonDefault';
import { useGeneralInformation } from './hooks/useGeneralInformation';
import { CardContent } from '@/components/views/Resolution886/CardContent';

export function GeneralInformationStep(): JSX.Element {
	const { isLoading, checkValidations, handleSetStepBack } = useGeneralInformation();

	return (
		<Row justify="center" align="middle" gutter={[16, 16]}>
			<Col span={24}>
				<CardContent>
					<GeneralInformationForm />
				</CardContent>
			</Col>
			<Col>
				<Row gutter={[16, 16]}>
					<Col>
						<ButtonDefault type="default" loading={isLoading} onClick={handleSetStepBack}>
							{I18n.get('Back')}
						</ButtonDefault>
					</Col>
					<Col>
						<ButtonDefault type="primary" loading={isLoading} onClick={checkValidations}>
							{I18n.get('Next')}
						</ButtonDefault>
					</Col>
				</Row>
			</Col>
		</Row>
	);
}
